"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypesConsumer = exports.TypesProvider = exports.withTypes = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _React$createContext = React.createContext({
  types: {},
  resolveType: function resolveType() {
    return undefined;
  }
}),
    Provider = _React$createContext.Provider,
    Consumer = _React$createContext.Consumer;

var _resolveType = function _resolveType(type, types) {
  if (!type) {
    return type;
  }

  if (typeof type === "string") {
    var resolved = _resolveType(types[type], types);

    return resolved ? (0, _extends3.default)({
      label: type
    }, resolved, {
      type: type
    }) : undefined;
  }

  if (!type.editor && type.type) {
    var _resolved = _resolveType(type.type, types);

    return _resolved ? (0, _extends3.default)({
      label: type.type
    }, _resolved, type) : undefined;
  }

  if (!type.type && !type.editor) {
    // synthesise an implicit object type
    var label = type.label,
        description = type.description,
        order = type.order,
        publishable = type.publishable,
        deletable = type.deletable,
        defaultValue = type.defaultValue,
        children = (0, _objectWithoutProperties3.default)(type, ["label", "description", "order", "publishable", "deletable", "defaultValue"]);
    return {
      type: "object",
      of: children,
      label: label,
      description: description,
      order: order,
      publishable: publishable,
      deletable: deletable,
      defaultValue: defaultValue
    };
  }

  return type;
};

var TypesProvider = function TypesProvider(_ref) {
  var types = _ref.types,
      props = (0, _objectWithoutProperties3.default)(_ref, ["types"]);
  return React.createElement(Provider, (0, _extends3.default)({
    value: {
      types: types,
      resolveType: function resolveType(type) {
        return _resolveType(type, types);
      }
    }
  }, props));
};

var TypesConsumer = Consumer;

function withTypes(BoundComponent, args) {
  return function (_React$Component) {
    (0, _inherits3.default)(Type, _React$Component);

    function Type() {
      (0, _classCallCheck3.default)(this, Type);
      return (0, _possibleConstructorReturn3.default)(this, (Type.__proto__ || (0, _getPrototypeOf2.default)(Type)).apply(this, arguments));
    }

    (0, _createClass3.default)(Type, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        return React.createElement(TypesConsumer, null, function (_ref2) {
          var types = _ref2.types,
              resolveType = _ref2.resolveType;
          return React.createElement(BoundComponent, (0, _extends3.default)({}, _this2.props, {
            types: types,
            resolveType: resolveType
          }));
        });
      }
    }]);
    return Type;
  }(React.Component);
}

exports.withTypes = withTypes;
exports.TypesProvider = TypesProvider;
exports.TypesConsumer = TypesConsumer;